<p>kendo-base works!</p>
